const Signature2 = () => (
  <div className="mt-10 text-[15px] px-8" style={{fontFamily: "Times New Roman"}}>
    <p>Yours faithfully,</p>
    <p>For <b>Optim Health and Wellness (OPC) Pvt. Ltd</b></p>
    <br/>
    <p className="uppercase"><b>ANINDITA KONWAR</b></p>
    <p>HR Executive</p>
    <p>Optim Health and Wellness (OPC) Pvt. Ltd.</p>
    <p>H. No. 01, Karbi Namghar Path, Guwahati - 36</p>
  </div>
);

export default Signature2;
